import { Component, JSX } from "react";
import "../../../App.css";
import IbssFooter from "../../../Components/Layout/Footer/IbssFooter";
import { appContext } from "../../../AppContext";
import { Box, Typography } from "@iconics/components";

class OutOfService extends Component
{
    private labels = appContext().labels;

    public render(): JSX.Element
    {
        return (
            <>
                <Box
                    style={{
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        height: '100vh',
                        padding: '40px 0px',
                        backgroundColor: 'var(--ui-background-alternate)',
                    }}>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Box>
                            <div className="mt-4" style={{ width: "1052px", backgroundColor: 'var(--ui-background-alternate)', borderRadius: '4px' }}>
                                <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
                                    <Box
                                        className="text-center"
                                        style={{ padding: "40px" }}
                                    >
                                        <Box
                                            style={{
                                                padding: '5px',
                                                gap: '10px',
                                                boxSizing: 'border-box',
                                            }}
                                        >
                                            <img src={`/images/Logos/iconics-ico-b-w.png`} style={{ height: "75px" }} alt="Iconics Roamer logo" />
                                        </Box>
                                        <Box >
                                            <Typography role='headline'>
                                                {this.labels.funcOutOfServiceTitle_S}
                                            </Typography>
                                        </Box>
                                        <Box
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <span
                                                style={{ width: "48%" }}
                                            >
                                                {this.labels.funcOutOfServiceDescription_S}
                                            </span>
                                        </Box>
                                    </Box>
                                </div>
                            </div>
                        </Box>
                    </div>
                    <IbssFooter />
                </Box>
            </>
        );
    }
}


export default OutOfService;
